import { BookingStatusEnum } from "@ryde/shared";
import {
  greenMui,
  greyMui,
  indigoMui,
  lightBlueMui,
  orangeMui,
  redMui,
  rydeColors,
} from "@ryde/theme";

export interface IStatusIndicatorBooking {
  status: BookingStatusEnum | null | undefined;
  fontSize?: string;
}

export interface IStatusIndicatorBookingControl {
  $bgColor: string;
  $leftColor: string;
  color: string;
  $translateKey: string;
  $dataE2eValue?: string;
  fontSize?: string;
}

export const StatusIndicatorBookingConst: Record<
  BookingStatusEnum,
  IStatusIndicatorBookingControl
> = {
  [BookingStatusEnum.Canceled]: {
    $bgColor: redMui.A200,
    $leftColor: redMui._900,
    color: rydeColors.white,
    $translateKey: "Canceled",
    $dataE2eValue: "Canceled",
  },
  [BookingStatusEnum.Draft]: {
    $bgColor: greyMui._100,
    $leftColor: greyMui._300,
    color: greyMui._500,
    $translateKey: "Draft",
    $dataE2eValue: "Draft",
  },
  [BookingStatusEnum.Routed]: {
    $bgColor: lightBlueMui._50,
    $leftColor: lightBlueMui._700,
    color: rydeColors.black,
    $translateKey: "Routed",
    $dataE2eValue: "Routed",
  },
  [BookingStatusEnum.New]: {
    $bgColor: indigoMui._50,
    $leftColor: indigoMui._600,
    color: rydeColors.black,
    $translateKey: "New",
    $dataE2eValue: "New",
  },
  [BookingStatusEnum.Rejected]: {
    $bgColor: orangeMui._50,
    $leftColor: orangeMui._900,
    color: rydeColors.black,
    $translateKey: "Rejected",
    $dataE2eValue: "Rejected",
  },
  [BookingStatusEnum.OnHold]: {
    $bgColor: orangeMui._600,
    $leftColor: orangeMui._900,
    color: rydeColors.white,
    $translateKey: "On_Hold",
    $dataE2eValue: "On Hold",
  },
  [BookingStatusEnum.Approved]: {
    $bgColor: greenMui._50,
    $leftColor: greenMui._700,
    color: rydeColors.black,
    $translateKey: "Approved",
    $dataE2eValue: "Approved",
  },
};
